import { Link } from "react-router-dom";
import React from "react";

const PrivacyPolicyContent = () => {
  return (
    <div className="text-start text-secondary" style={{ maxHeight: '50vh', overflowY: 'auto', scrollbarWidth: 'none' }}>

      {/* --- Part 1: Privacy Notice --- */}
      <section className="mb- border-bottom pb-4">
        <h4 className="fw-bold text-dark mb-3">PRIVACY NOTICE</h4>
        <p className="small">
          PSC is a Federal Executive Body under Section 153 (m) of the Constitution of the Federal Republic of Nigeria, 1999 (as amended) that processes data in furtherance of our mandate as the sole statutory body empowered to appoint, promote, dismiss and exercise disciplinary control over all officers in the Nigeria Police Force (except the Inspector-General of Police).
        </p>
        <p className="small">
          We rely on lawful bases for data processing such as consent, substantial public interest, legal obligation and contract. We process various categories of your data so as to ensure that only suitably qualified Nigerians are recruited into the Nigeria Police Force. Subject to your rights as a data subject, this Portal uses “cookies” which may help process your pattern of engagement and thereby create automated responses and notifications that seem most likely to suit your interest. This notice applies to the Police Service Commission.
        </p>
        <div className="text-center py-2">
          For queries about how we protect your data rights, please contact us :
          <li><strong>Email:</strong> <a href="mailto:dpr@psc.gov.ng">dpr@psc.gov.ng</a></li>
          <li><strong>Phone:</strong> 07054992071 </li>
        </div>
        <div className="alert alert-light border mt-3 text-center">
          <strong>Please read <Link to="/data-protection-privacy">OUR DATA PROTECTION AND PRIVACY POLICY</Link></strong>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyContent;
